import React from 'react';

export const NoMatch = () => (
  <div>
    <h2>Sorry, I couldn't find that page, I am still building a search engine. :)</h2>
  </div>
)
